import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-clearscore.component.scss';
var FormItemClearscore = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemClearscore, _super);
    function FormItemClearscore(element) {
        return _super.call(this, element) || this;
    }
    FormItemClearscore.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-clearscore__button');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemClearscore.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemClearscore.prototype.submitForm = function (pForm) {
        var _this = this;
        var _description = this.form.querySelector("input[name=description]");
        var _firstname = this.form.querySelector("input[name=name]");
        var _lastName = this.form.querySelector("input[name=surname]");
        var _saIdNum = this.form.querySelector("input[name=sa-identity-number]");
        var _contactNumber = this.form.querySelector("input[name=contact-number]");
        var _timeToCall = this.form.querySelector("input[name=timeToCall]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _postData = {
            'description': (_description ? _description.value : ""),
            'fullName': ((_firstname ? _firstname.value : "") + " " + (_lastName ? _lastName.value : "")),
            'idNum': (_saIdNum ? _saIdNum.value : ""),
            'timeToCall': (_timeToCall ? _timeToCall.value : ""),
            'contact': (_contactNumber ? _contactNumber.value : ""),
            'popiConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO"))
        };
        this.showDisplayView("loader");
        // variables
        var url = "/services/SubmitApplicationForm.jsp";
        ;
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (pResponse) {
            // service ok
            if (!pResponse) {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
                _this.showDisplayView("error");
            }
            else if (pResponse.data) {
                if (pResponse.data.toString().toLowerCase().includes("invalid")) {
                    _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                    _this.showDisplayView("error");
                }
                else {
                    _this.analyticsService.dtmFormComplete('complete', pResponse.data);
                    _this.showDisplayView("success");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.showDisplayView("error");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemClearscore.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemClearscore;
}(Base));
export { FormItemClearscore };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-clearscore/form-item-clearscore.component.ts
// module id = 879
// module chunks = 0